import { capitalize } from "lodash";
import { BCGraph, BCScoreX } from "services";

export const convertChartLayout = (data: BCGraph) => {
    if (!data.score_x) return;

    const allBehaviours = Object.entries(data.score_x);

    // Get all Parent Behaviours (the ones with _TOTAL in the name)
    const behaviours = allBehaviours.reduce((acc, axis) => {
        if (axis[1].id.includes("_TOTAL")) {
            const behaviour = [axis[0], { ...axis[1], name: axis[1].synonym }] as [string, BCScoreX & { name: string }];
            return [...acc, behaviour];
        }
        return acc;
    }, [] as [string, BCScoreX & { name: string }][]);

    // Get all Child Behaviours (those whose id includes a parent name in it)
    // AMPLIFIER_DARK_TRIAD_TOTAL is a special case, so inside map loop we use a special parent name "Collaborative Style"
    const subBehavioursWithParents = behaviours.flatMap((behaviour) => {
        const behaviourName = behaviour[1].id.split("_TOTAL")[0];
        const correspondingSubBehaviours = allBehaviours
            .filter((b) => b[1].id.includes(behaviourName) && !b[1].id.includes("_TOTAL"))
            .map((b) => {
                const parent = capitalize(behaviourName);
                const DarkTriad = "Amplifier_dark_triad";
                const isDarkTriad = parent === DarkTriad;
                return [b[0], { ...b[1], name: b[1].synonym, parent: isDarkTriad ? "Collaborative Style" : parent }];
            });

        return correspondingSubBehaviours;
    });

    const axes = Object.fromEntries([...behaviours, ...subBehavioursWithParents]);

    return axes;
};
